import { useCallback } from "react";

import { useHistory } from "react-router-dom";

export const useHistoryWithFallbackUrl = (fallbackUrl: string) => {
  const history = useHistory();

  return useCallback(() => {
    if (history.length === 0 || history.action === "POP") {
      history.push(fallbackUrl);
      return;
    }

    history.goBack();
  }, [history, fallbackUrl]);
};
